import type { FC } from "react";

import { SiteGroupsSearchForm } from "src/app/features/SiteGroup/components/forms/SiteGroupsSearchForm";
import { SiteGroupsTable } from "src/app/features/SiteGroup/components/tables/SiteGroupsTable";
import type { SiteGroupList } from "src/app/features/SiteGroup/types/SiteGroupList";
import { PageLayout, PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { NoAccessLayout } from "../../../../components/AppLayout/components/Content/components/NoAccessLayout";
import { Actions, ResourceManager } from "../../../../components/ResourceManager/ResourceManager";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import type { NoneOwnProps } from "../../../../core/types";

export const SiteGroupPage: FC<NoneOwnProps> = () => {
    const table = <SiteGroupsTable />;
    const searchForm = <SiteGroupsSearchForm />;
    const hasAccess = canAccess(ResourceName.SITE_GROUPS, "canRead");

    return (
        <PageLayout name="siteGroups_page">
            {hasAccess ? (
                <>
                    <PageTitle translationKey="menu.siteGroups" />
                    <ResourceManager<SiteGroupList>
                        useDataGroup
                        dataMapperKey="siteGroupsTableData"
                        resource={ResourceName.SITE_GROUPS}
                        table={table}
                        actions={[Actions.ADD, Actions.DELETE, Actions.FORM_COPY, Actions.EXPORT, Actions.IMPORT_DATA]}
                        searchForm={searchForm}
                    />
                </>
            ) : (
                <NoAccessLayout />
            )}
        </PageLayout>
    );
};
